import { Button } from "@/shared/ui/button";
import { ButtonGroup } from "@/shared/ui/button-group";
import { useEffect, useState } from "react";

interface RbiAttributionPromptProps {
  pendingRbi: { batterId: string | null; runs: number } | null;
  onApplyRbi: (runs: number) => boolean | Promise<boolean>;
  pending?: boolean;
  unknown?: boolean;
}

export function RbiAttributionPrompt({
  pendingRbi,
  onApplyRbi,
  pending = false,
  unknown = false,
}: RbiAttributionPromptProps) {
  const [submittingRuns, setSubmittingRuns] = useState<number | null>(null);
  useEffect(() => setSubmittingRuns(null), [pendingRbi]);
  if (!pendingRbi) return null;
  const isPending = pending || submittingRuns !== null;

  return (
    <section className="mb-2 flex flex-wrap items-center justify-between gap-2 rounded-[var(--radius-sm)] border border-warning/60 bg-warning/12 px-3 py-2">
      <strong className="text-sm text-warning">
        {pendingRbi.runs} run{pendingRbi.runs > 1 ? "s" : ""} scored — RBI to
        batter?
      </strong>
      <ButtonGroup>
        {Array.from({ length: pendingRbi.runs + 1 }, (_, runs) => (
          <Button
            key={runs}
            type="button"
            size="sm"
            variant="outline"
            pending={submittingRuns === runs}
            pendingLabel={unknown ? "CHECKING…" : `${runs}`}
            disabled={isPending}
            aria-pressed={submittingRuns === runs || undefined}
            onClick={async () => {
              setSubmittingRuns(runs);
              const succeeded = await onApplyRbi(runs);
              if (!succeeded) setSubmittingRuns(null);
            }}
            className="min-w-9"
          >
            {runs}
          </Button>
        ))}
      </ButtonGroup>
    </section>
  );
}
